/* AMLAND home page: hero slider, product tabs and rails, quick add to bag, scroll reveal. */
(function () {
  'use strict';
  if (window.__amxHome) return;
  window.__amxHome = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);
  if (!design && !reduce) document.documentElement.classList.add('amx-js');

  /* ---------- Reveal ---------- */
  var io = 'IntersectionObserver' in window && !design ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  function reveal(root) {
    root.querySelectorAll('[data-amx-reveal]').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  /* ---------- Hero ---------- */
  function initHero(hero) {
    var slides = [].slice.call(hero.querySelectorAll('.amx-slide'));
    var dots = [].slice.call(hero.querySelectorAll('.amx-dot'));
    if (slides.length < 2) { if (slides[0]) slides[0].classList.add('is-active'); return; }
    var dur = (parseFloat(hero.dataset.speed) || 6) * 1000;
    hero.style.setProperty('--dur', dur / 1000 + 's');
    var i = 0, timer = null, paused = false, started = Date.now(), left = dur;

    function hydrate(slide) {
      var t = slide && slide.querySelector('template[data-amx-later]');
      if (t) t.parentNode.replaceChild(t.content, t);
    }
    function hydrateAll() { slides.forEach(hydrate); }
    if (document.readyState === 'complete') setTimeout(hydrateAll, 300);
    else window.addEventListener('load', function () { setTimeout(hydrateAll, 300); });

    function go(n, user) {
      hydrate(slides[(n + slides.length) % slides.length]);
      slides[i].classList.remove('is-active');
      dots[i] && dots[i].classList.remove('is-active');
      slides[i].setAttribute('aria-hidden', 'true');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      slides[i].removeAttribute('aria-hidden');
      if (dots[i]) {
        dots[i].classList.remove('is-active');
        void dots[i].offsetWidth;
        dots[i].classList.add('is-active');
      }
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      left = dur;
      schedule();
      if (user) hero.classList.remove('is-paused');
    }
    function schedule() {
      clearTimeout(timer);
      if (paused || reduce || design) return;
      started = Date.now();
      timer = setTimeout(function () { go(i + 1); }, left);
    }
    function pause() {
      if (paused) return;
      paused = true;
      clearTimeout(timer);
      left = Math.max(400, left - (Date.now() - started));
      hero.classList.add('is-paused');
    }
    function resume() {
      if (!paused) return;
      paused = false;
      hero.classList.remove('is-paused');
      schedule();
    }

    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k, true); }); });
    var prev = hero.querySelector('[data-amx-prev]');
    var next = hero.querySelector('[data-amx-next]');
    prev && prev.addEventListener('click', function () { go(i - 1, true); });
    next && next.addEventListener('click', function () { go(i + 1, true); });
    hero.addEventListener('mouseenter', pause);
    hero.addEventListener('mouseleave', resume);
    hero.addEventListener('focusin', pause);
    hero.addEventListener('focusout', function (e) { if (!hero.contains(e.relatedTarget)) resume(); });
    hero.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(i - 1, true);
      if (e.key === 'ArrowRight') go(i + 1, true);
    });
    document.addEventListener('visibilitychange', function () { document.hidden ? pause() : resume(); });

    var x0 = null, y0 = 0;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(i + (dx < 0 ? 1 : -1), true);
      x0 = null;
    });

    slides.forEach(function (s, k) { if (k) s.setAttribute('aria-hidden', 'true'); });
    go(0);

    hero._amxSelect = function (k) { go(k, true); pause(); };
  }

  /* ---------- Rails ---------- */
  function initRail(wrap) {
    var rail = wrap.querySelector('.amx-rail');
    if (!rail) return;
    var prev = wrap.querySelector('[data-amx-rail-prev]');
    var next = wrap.querySelector('[data-amx-rail-next]');
    var bar = wrap.parentNode.querySelector('.amx-rail-bar i') || wrap.querySelector('.amx-rail-bar i');
    function step() {
      var card = rail.firstElementChild;
      if (!card) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      var per = Math.max(1, Math.floor((rail.clientWidth + gap) / (card.offsetWidth + gap)));
      return per * (card.offsetWidth + gap);
    }
    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max - 2;
      if (bar) {
        var w = rail.scrollWidth ? Math.min(1, rail.clientWidth / rail.scrollWidth) : 1;
        var track = bar.parentNode.clientWidth;
        bar.style.setProperty('--w', w * 100 + '%');
        bar.style.setProperty('--x', (max > 0 ? (rail.scrollLeft / max) * (track - track * w) : 0) + 'px');
        bar.parentNode.style.visibility = w >= 1 ? 'hidden' : '';
      }
    }
    prev && prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    next && next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    wrap._amxUpdate = update;
    update();
  }

  /* ---------- Tabs ---------- */
  function initTabs(section) {
    var tabs = [].slice.call(section.querySelectorAll('.amx-tab'));
    if (!tabs.length) return;
    var panels = tabs.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });
    var links = [].slice.call(section.querySelectorAll('[data-amx-tab-link]'));
    function select(k, focus) {
      tabs.forEach(function (t, n) {
        var on = n === k;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (!panels[n]) return;
        panels[n].hidden = !on;
        if (on) {
          panels[n].classList.remove('is-entering');
          void panels[n].offsetWidth;
          panels[n].classList.add('is-entering');
          var rw = panels[n].querySelector('.amx-rail-wrap');
          if (rw) { rw.querySelector('.amx-rail').scrollLeft = 0; rw._amxUpdate && rw._amxUpdate(); }
        }
      });
      links.forEach(function (a, n) { a.hidden = n !== k; });
      if (focus) tabs[k].focus();
    }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { select(k); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); select((k + 1) % tabs.length, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select((k - 1 + tabs.length) % tabs.length, true); }
      });
    });
  }

  /* ---------- Quick add ---------- */
  function closePickers(except) {
    document.querySelectorAll('.amx-card.is-picking').forEach(function (c) {
      if (c !== except) { c.classList.remove('is-picking'); var b = c.querySelector('[data-amx-qa]'); b && b.setAttribute('aria-expanded', 'false'); }
    });
  }
  function addToCart(id, card, btn) {
    if (btn && btn.classList.contains('is-busy')) return;
    var msg = card.querySelector('.amx-sizes-msg');
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (drawer && typeof drawer.renderContents === 'function') {
      body.sections = (drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble']).join(',');
      body.sections_url = window.location.pathname;
    }
    if (btn) btn.classList.add('is-busy');
    if (msg) { msg.textContent = ''; msg.classList.remove('ok'); }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (btn) btn.classList.remove('is-busy');
        if (!res.ok || res.json.status) {
          if (msg) msg.textContent = res.json.description || res.json.message || 'Could not add this size. Please try another.';
          return;
        }
        card.classList.remove('is-picking');
        if (drawer && typeof drawer.renderContents === 'function' && res.json.sections) {
          var state = res.json.items ? res.json.items[0] : res.json;
          state.sections = res.json.sections;
          drawer.classList.remove('is-empty');
          drawer.renderContents(state);
        } else {
          window.location.href = root + 'cart';
        }
        document.dispatchEvent(new CustomEvent('amx:cart:added', { detail: res.json }));
      })
      .catch(function () {
        if (btn) btn.classList.remove('is-busy');
        if (msg) msg.textContent = 'Something went wrong. Please try again.';
      });
  }
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-amx-qa]');
    if (qa) {
      e.preventDefault();
      var card = qa.closest('.amx-card');
      if (qa.dataset.variant) { addToCart(qa.dataset.variant, card, qa); return; }
      var open = !card.classList.contains('is-picking');
      closePickers(card);
      card.classList.toggle('is-picking', open);
      qa.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var first = card.querySelector('.amx-size:not([disabled])'); first && first.focus({ preventScroll: true }); }
      return;
    }
    var size = e.target.closest('.amx-size');
    if (size && !size.disabled) { e.preventDefault(); addToCart(size.dataset.variant, size.closest('.amx-card'), size); return; }
    var close = e.target.closest('.amx-sizes-close');
    if (close) { e.preventDefault(); closePickers(null); return; }
    if (!e.target.closest('.amx-sizes')) closePickers(null);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePickers(null); });

  /* ---------- Init ---------- */
  function init(root) {
    root.querySelectorAll('[data-amx-hero]').forEach(function (h) { if (!h._amxReady) { h._amxReady = 1; initHero(h); } });
    root.querySelectorAll('.amx-rail-wrap').forEach(function (w) { if (!w._amxReady) { w._amxReady = 1; initRail(w); } });
    root.querySelectorAll('[data-amx-tabs]').forEach(function (s) { if (!s._amxReady) { s._amxReady = 1; initTabs(s); } });
    reveal(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* Collection filters, sorting and "load more" swap the grid HTML; the review widget
     only refills new rating mounts when its own mount count changes, so nudge it. */
  if (window.MutationObserver) {
    var rvTimer = null;
    new MutationObserver(function (records) {
      var fresh = false;
      for (var i = 0; i < records.length && !fresh; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.matches('.amx-rv') || n.querySelector('.amx-rv'))) { fresh = true; break; }
        }
      }
      if (!fresh) return;
      clearTimeout(rvTimer);
      rvTimer = setTimeout(function () {
        var w = window.__akilliReviewsWidget;
        if (w && typeof w.refresh === 'function') w.refresh(true);
      }, 250);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:block:select', function (e) {
    var hero = e.target.closest('[data-amx-hero]');
    if (hero && hero._amxSelect) hero._amxSelect([].indexOf.call(hero.querySelectorAll('.amx-slide'), e.target));
  });
})();
